var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{class:{
    'bootstrap-validation-background--hidden': _vm.hideBootstrapBackground === true,
  },on:{"submit":function($event){$event.preventDefault();$event.stopPropagation();return _vm.submit($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }